<template>
    <div>
        <Hero />

        <div class="px-4 md:px-20 text-xl flex flex-col gap-y-4 mt-5">
            <p>
                While attending physical church services is the best option for us, we understand that sometimes, there may be some constraints.
            </p>
            <p>
                That’s why we have an avenue for you to listen to us online.
            </p>
            <p>Click the link below to listen to us live. </p>
        </div>

        <div class="grid py-5 gap-y-8 px-8 md:p-20">
            <div class="h-60 text-white">
                <iframe src="https://the-saints-gathering-church.mixlr.com/embed" frameborder="0" scrolling="no" height="100%" width="100%"></iframe><small><a href="https://mixlr.com/" style="color:#1a1a1a;display:block;font-family:Helvetica,sans-serif;font-size:11px;text-align:left;padding: 4px 0;">THE SAINTS GATHERING CHURCH is on Mixlr</a></small>
            </div>

            <div class="flex md:flex-col justify-center items-center gap-5 mt-10">
                <a href="https://the-saints-gathering-church.mixlr.com" target="_blank">
                    <PrimaryButton content="Go to MIxlr" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import PrimaryButton from '../PrimaryButton.vue';
import Hero from './Hero.vue';
</script>

<style scoped>
.bg{
    background-image: url('../../assets/images/mixlr_section.png');
    background-size: cover;
}
</style>